import {hosService} from '../../lib/service/hos'
/**
 *
 * 转诊安排页面的混合文件
 *
 * */
export const acceptMixin = {
    methods:{
        // 拒绝会诊申请
        async refuseMixin(from){
            if(await hosService.refuse({
                id:this.orderId,
                refuseReason:from
            })){
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$router.back();
            }
        },
        // 确认会诊申请
        async affirmMixin(from){
            if(await hosService.affirm({
                id:this.orderId,
                referralResult:'1',
                remark:from.context,
                acceptTime:from.date,
                acceptHosId:this.detailObj.hopeHosId
            })){
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$router.back();
            }
        },
        // 修改会诊时间
        async updateMixin(from){
            if(await hosService.affirm({
                id:this.orderId,
                referralResult:'1',
                remark:this.detailObj.remark,
                acceptTime:from,
                acceptHosId:this.detailObj.hopeHosId
            })){
                this.$message({
                    message: '修改成功',
                    type: 'success'
                });
                this.$router.back();
            }
        },
        //接收方查询会诊列表
        async queryAcceptList(form){
            const {list,page}  =  await hosService.acceptList(form);
            return {list,page}
        }
    }
}